import { useQuery } from "@tanstack/react-query";

import { QueryKey } from "@/constants/shared";
import { makeRequest } from "@/network/api";
import { PPScores } from "@/types";

export const usePPScores = (walletAddress: string | undefined) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: [QueryKey.PPScores, walletAddress],
    queryFn: async (): Promise<{
      ppScores: PPScores;
      walletAddress: string;
    }> => {
      const response = await makeRequest(
        `stats/pp-totals?walletAddress=${walletAddress}`,
      );
      const responseJson = await response.json();
      if (responseJson.error) {
        throw new Error(responseJson.error);
      }
      return responseJson.data;
    },
    enabled: Boolean(walletAddress),
    refetchOnMount: false,
  });

  const { ppScores } = data ?? {};

  const pointsDelta = ppScores
    ? Math.max(ppScores.activeXp.totalXp - ppScores.prevXp.totalXp, 0)
    : null;
  return {
    ppScores,
    pointsDelta,
    isLoading: isLoading || !walletAddress,
    isError,
  };
};
